<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择生产订单"
      width="1300px"
      top="2vh">
    <view-table
        ref="tableSelect"
        :columns="columnsProperty"
        :filter="filter"
        module="basic"
        url="sapProductionOrders"
        @select="selectHandle">
      <template slot="otherBtn">
        <el-button type="primary" @click="selectRows">添加</el-button>
      </template>
      <template slot="adSearch">
        <el-form ref="form" :inline="true" :model="filter">
          <el-form-item label="生产订单">
            <el-input v-model.trim="filter.orders" placeholder="请输入工单编号" clearable/>
          </el-form-item>
          <el-form-item label="物料编号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入物料编号" clearable/>
          </el-form-item>
          <el-form-item label="物料名称">
            <el-input v-model.trim="filter.materialName" placeholder="请输入物料名称" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </view-table>
  </el-dialog>
</template>

<script>
  import ViewTable from "@/components/ViewTable";

  export default {
    name: "ProductionOrderSelect",
    components: {ViewTable},
    data() {
      return {
        dialogVisible: false,
        isMultiple: true,
        filter: {
          billNo: "",
          productionOrderNo: "",
          materialNo: "",
          materialName: "",
          feedingMaterial: true,
          queryType:null,
          isMultiple: false,
        },
        columnsProperty: [
          {
            tooltip: true,
            title: "派工单号",
            key: "billNo",
            width: 150,
            align: "center",
          },
          {
            tooltip: true,
            title: "发料状态",
            key: "feedingStatusName",
            width: 90,
            align: "center",
          },
          {
            tooltip: true,
            title: "工单状态",
            key: "statusName",
            width: 90,
            align: "center",
          },
          {
            tooltip: true,
            title: "验证状态",
            key: "verificationStatusName",
            width: 90,
            align: "center",
          },
          {
            tooltip: true,
            title: "工单编号",
            key: "productionOrderNo",
            width: 150,
            align: "center",
          },
          {
            tooltip: true,
            title: "工单类型",
            key: "prodOrderTypeName",
            width: 100,
            align: "center",
          },
          {
            tooltip: true,
            title: "物料编号",
            key: "materialNo",
            width: 160,
            align: "center",
          },
          {
            title: "物料名称",
            key: "materialName",
            minWidth: 360,
            tooltip: true,
          },
          {
            title: "规格",
            key: "specification",
            width: 220,
            tooltip: true,
          },
          {
            tooltip: true,
            title: "派工数量",
            key: "quantity",
            width: 90,
            align: "center",
          },
          {
            title: "操作",
            key: "action",
            align: "center",
            width: 80,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      open(produtctionFilter) {
        this.isMultiple = produtctionFilter.isMultiple;
        this.filter=produtctionFilter;
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.form.resetFields();
          this.$refs.tableSelect.loadData();
        });
      },
      selectHandle(selection) {
        this.selection = selection;
      },

      selectRows() {
        if (!this.isMultiple) {
          if (this.selection.length > 1) {
            return this.$message.error("只能选择一条数据！");
          }
        }
        this.dialogVisible = false;
        this.$emit("select", this.selection);
      },
    },
  };
</script>

<style scoped>

</style>